module.exports = function() {
  return new Worker(__webpack_public_path__ + "02ea863db7db0ddbd7bf.worker.js");
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/worker-loader/dist/cjs.js!./src/abcSvg/worker.ts
// module id = 42
// module chunks = 0